var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 793",
    clipPath: "url(#clip0_177_15696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow 3",
    d: "M2 14.25C1.58579 14.25 1.25 14.5858 1.25 15C1.25 15.4142 1.58579 15.75 2 15.75V14.25ZM27.5303 15.5303C27.8232 15.2374 27.8232 14.7626 27.5303 14.4697L22.7574 9.6967C22.4645 9.40381 21.9896 9.40381 21.6967 9.6967C21.4038 9.98959 21.4038 10.4645 21.6967 10.7574L25.9393 15L21.6967 19.2426C21.4038 19.5355 21.4038 20.0104 21.6967 20.3033C21.9896 20.5962 22.4645 20.5962 22.7574 20.3033L27.5303 15.5303ZM2 15.75H27V14.25H2V15.75Z",
    fill: "#FCF5F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_177_15696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonArrow);
export default __webpack_public_path__ + "static/media/button-Arrow.b0c2fbe5395bb3821f49d6835b2e29ab.svg";
export { ForwardRef as ReactComponent };